import React, {useContext} from 'react'
import ListContext from '../../context/list/ListContext'
import {CheckBox} from '../ui/FieldNames'
import {LocationsItems} from './LocationsItems'

export const ShoppingListContainer = () => {
  const listContext = useContext(ListContext)

  const {currentList, updateList} = listContext

  console.log('ShoppingListContainer - currentList:', currentList)
  console.log('ShoppingListContainer - currentList.items:', currentList?.items)
  if (currentList?.items && currentList.items.length > 0) {
    console.log('First item:', currentList.items[0])
    console.log('First item.item:', currentList.items[0].item)
    console.log('First item.name:', currentList.items[0].name)
  }

  if (!currentList || !currentList.items || currentList.items.length === 0) {
    return <div>No items in this list</div>
  }

  // Get unique list of locations from the list items
  const getUniqueLocations = (list) => {
    const locations = list.items
      .filter(listItem => listItem && listItem.location)
      .map(listItem => listItem.location.name)
    return [...new Set(locations)].sort()
  }

  // Split items into those with and without locations
  const splitItemsByLocation = (list) => {
    const withLocations = list.items.filter(item => item && item.location)
    const withoutLocations = list.items.filter(item => item && !item.location)
    return [withLocations, withoutLocations]
  }

  const uniqueLocations = getUniqueLocations(currentList)
  const shoppedItems = currentList.items.filter((item) => item.shopped)
  const [itemsWithLocations, itemsWithoutLocations] = splitItemsByLocation(currentList)

  const checkIfAllItemsShopped = (list) => {
    list.shopped = list.items
      .map((item) => item.shopped)
      .every((shoppedVal) => shoppedVal)
      ? true
      : false
    return list
  }

  const onChange = (e) => {
    const itemId = e.target.name
    const listItem = currentList.items.find((item) => {
      const currentItemId = item.item?._id || item.item || item._id
      return currentItemId === itemId
    })
    
    if (!listItem) {
      console.error('Item not found for ID:', itemId)
      return
    }

    listItem.shopped = e.target.checked
    const updatedList = checkIfAllItemsShopped(currentList)
    console.log('sending list as', updatedList)
    updateList(updatedList)
  }

  const getCheckBoxes = ({preChecked, collection, objToFilterOn}) => {
    // Filter by location if specified
    collection =
      typeof objToFilterOn !== 'undefined'
        ? collection.filter((item) =>
            item && item.location && item.location.name === objToFilterOn
          )
        : collection
    
    const preCheckedIds = preChecked
      .filter(checked => checked && (checked.item?._id || checked.item))
      .map(checked => checked.item?._id || checked.item)
    
    // Create checkboxes - handle both populated and non-populated items
    return collection
      .filter(listItem => listItem && (listItem.item || listItem.name))
      .map((listItem, i) => {
        // Get item ID - could be populated object or just ID string
        const itemId = listItem.item?._id || listItem.item || listItem._id
        // Get item name - from populated item or denormalized name field
        const itemName = listItem.item?.name || listItem.name || 'Unknown Item'
        
        return (
          <CheckBox
            key={i}
            idString={itemId}
            labelString={itemName}
            action={onChange}
            checked={preCheckedIds.includes(itemId)}
            metaOptions={{
              required: false,
              disabled: false,
              style: {},
              checkBoxGroup: objToFilterOn || 'default',
              extraClasses: ['full-width-checkbox', 'checkbox-buffer']
            }}
          />
        )
      })
  }

  return (
    <div style={{padding: '1rem', width: '100%', border: 'solid black 3px'}}>
      <ul>
        <>
          <div>
            {/* {console.log(
              'current list all shopped',
              currentList.items.map((item) => [item.shopped, item.name]),
              currentList.items.map((item) => item.shopped).every((t) => t),
              currentList
            )} */}
            {uniqueLocations.map((locationName, i) => (
              <LocationsItems
                key={i}
                locationName={locationName}
                checkBoxes={getCheckBoxes({
                  preChecked: shoppedItems,
                  collection: itemsWithLocations,
                  objToFilterOn: locationName,
                })}
              />
            ))}
            {itemsWithoutLocations.length > 0 && (
              <LocationsItems
                locationName={'Unorganized'}
                checkBoxes={getCheckBoxes({
                  preChecked: shoppedItems,
                  collection: itemsWithoutLocations,
                })}
              />
            )}
          </div>
        </>
      </ul>
    </div>
  )
}
